import { gql } from "@apollo/client";
import { InvoiceOperationResult } from "../types/RealtimeInvoiceType";

export const SUBMIT_REALTIME_INVOICE_APPLICATION = gql`
    mutation SubmitRealtimeInvoiceApplication(
        $settlementClientId: ID!
        $aggregateIds: [ID!]!
        $dueDate: Int
    ) {
        submitRealtimeInvoiceApplication(
            settlementClientId: $settlementClientId
            aggregateIds: $aggregateIds
            dueDate: $dueDate
        ) {
            success
            code
            message
            invoiceId
            invoiceNo
        }
    }
`;

export const VOID_REALTIME_INVOICE = gql`
    mutation VoidRealtimeInvoice($invoiceId: ID!, $cancelReason: String!) {
        voidRealtimeInvoice(invoiceId: $invoiceId, cancelReason: $cancelReason) {
            success
            code
            message
            invoiceId
            invoiceNo
        }
    }
`;

export interface SubmitRealtimeInvoiceApplicationResponse {
    submitRealtimeInvoiceApplication: InvoiceOperationResult;
}

export interface VoidRealtimeInvoiceResponse {
    voidRealtimeInvoice: InvoiceOperationResult;
}

export const EXPORT_REALTIME_INVOICE_ORDER_DETAIL = gql`
    mutation ExportRealtimeInvoiceOrderDetail($invoiceId: ID!) {
        exportRealtimeInvoiceOrderDetail(invoiceId: $invoiceId)
    }
`;

export interface ExportRealtimeInvoiceOrderDetailResponse {
    exportRealtimeInvoiceOrderDetail: string;
}
